import { isNetworkSlow } from '../timing/isNetworkSlow';
const isSlow = isNetworkSlow();
/** Scale factor, multiply to get msec, divide to get minutes */
export const ONE_MINUTE_IN_MSEC = 60000;
/** 5 minutes in milliseconds */
export const FIVE_MINUTES_IN_MSEC = 5 * ONE_MINUTE_IN_MSEC;
/** Scale factor, multiply to get msec, divide to get hours */
export const ONE_HOUR_IN_MSEC = 60 * ONE_MINUTE_IN_MSEC;
/** Default timeout for stuff that really doesn't refresh often. (ie: the first reply to a long conversation) */
export const SLOW_DATA_STALE_TIME_MSEC = 15 * ONE_MINUTE_IN_MSEC;
/** Default timeout for big list useQuery caches to go stale. (ie: listgrid content) */
export const LIST_DATA_STALE_TIME_MSEC = 10 * ONE_MINUTE_IN_MSEC;
/** Default timeout for single-item useQuery caches to go stale. (ie: details page content) */
export const SINGLETON_DATA_STALE_TIME_MSEC = isSlow
    ? // Slow connections should use a longer timeout
        9 * ONE_MINUTE_IN_MSEC
    : // Fast connections should use a shorter timeout
        6 * ONE_MINUTE_IN_MSEC;
/**
 * > # WARNING: Uses a _lot_ of bandwidth!
 * > Only use this for things that need to feel "live" or "instant".
 *
 * Timeout length for fast moving useQuery caches to go stale. (ie: chat/comms features).
 *
 * Most content should use either `SINGLETON_DATA_STALE_TIME_MSEC` or
 * `LIST_DATA_STALE_TIME_MSEC`.
 */
export const FAST_DATA_STALE_TIME_MSEC = isNetworkSlow()
    ? // If the user is on a slow connection, use a longer timeout
        3 * ONE_MINUTE_IN_MSEC
    : // If the user is on a fast connection, use a shorter timeout
        ONE_MINUTE_IN_MSEC;
